import React from 'react';
import { Box, useTheme, keyframes } from '@mui/material';

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  70% {
    transform: translateY(0);
    opacity: 1;
  }
  80% {
    transform: translateY(-3px);
    opacity: 0.5;
  }
  90% {
    transform: translateY(0);
    opacity: 1;
  }
`;

type Props = {
  colors?: string[];
  size?: number;
  spacing?: number;
  delay?: number;
};

export const BouncingDots: React.FC<Props> = ({
  size = 4,
  spacing = 2,
  delay = 300
}) => {
  const { palette } = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: `${spacing}px` }}>
      {[0, 1, 2].map((index) => (
        <Box
          key={index}
          sx={{
            borderRadius: '99%',
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor: palette.primary.main,
            animation: `${bounce} 1.2s infinite`,
            animationDelay: `${index * delay}ms`
          }}
        />
      ))}
    </Box>
  );
};
